import { Component, OnInit, Input } from '@angular/core';

import { InvestOutputDetail } from '@classes/invest/invest-sic/invest-output-detail';

@Component({
    selector: 'app-loaning-datatable',
    templateUrl: './loaning-datatable.component.html',
    styleUrls: ['./loaning-datatable.component.scss']
})
export class LoaningDatatableComponent implements OnInit {
    @Input() data: InvestOutputDetail;

    constructor() { }

    ngOnInit() {
    }
}
